// $.myHome по требованиям СОПР 1.0 https://cianru.atlassian.net/wiki/spaces/ML/pages/443613219
import { IApplicationState } from '../../../types/redux';
import { TPage } from '../../../types/analytics';
import { TDeviceType } from '@cian/ui-kit';
import { selectBreadcrumbs, selectNewbuilding } from '../../../selectors/newbuilding';

export function getTrackingPageParam(state: IApplicationState, deviceType: TDeviceType): TPage {
  const newbuilding = selectNewbuilding(state);
  const breadcrumbs = selectBreadcrumbs(state);

  return {
    pageType: 'BuildingProgressJK',
    siteType: deviceType === 'phone' ? 'mobile' : deviceType,
    extra: {
      customPageURL: newbuilding.customPageUrl,
      breadCrumbs: breadcrumbs.map(item => item.title),
      offerID: Number(newbuilding.id),
      objectType: 'JK',
      dealType: 'other',
    },
  };
}
